import { iframeResizer } from 'iframe-resizer';
import { useEffect, useRef, useState } from "react";
import { navigate, PaymentOptionEnum, useGetWSPayPaymentDetails } from "src/common";
import { WsPayPaymentDetailsDto } from 'src/common/apiGraphql/types/types';
import config from "src/config";
import { AppRoutes } from "src/pages/app";

export interface WsPayIframeProps {
  offerId: string;
  paymentOption: PaymentOptionEnum;
  paymentType: string;
  title: string;
}

const trustedIframeOrigins = (): string[] => {
  const origins = [window.location.origin];
  try {
    origins.push(new URL(config.REACT_APP_WSPAY_URL).origin);
  } catch {
    // WSPay URL not configured (local dev) — our own origin only.
  }
  return origins;
};

export const WsPayIframe = ({ offerId, paymentOption, paymentType, title }: WsPayIframeProps) => {
  const formRef = useRef<HTMLFormElement>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const [getWSPayPaymentDetails, { loading, error, data }] = useGetWSPayPaymentDetails();

  useEffect(() => {
    getWSPayPaymentDetails(paymentType).then((result: WsPayPaymentDetailsDto | null | undefined) => {
      if (!result) {
        navigate(AppRoutes.WEBSHOP.STEP_4);
        return;
      }
      setIsLoaded(true);
    }).catch(() => {
      navigate(AppRoutes.WEBSHOP.CHECKOUT_FAILURE + '?ErrorCodes=WSPAY_PAYMENT_DETAILS_ERROR');
    });
  }, []);

  useEffect(() => {
    if (data?.getWSPayPaymentDetails && isLoaded) {
      if (formRef.current) {
        formRef.current.submit();
        // Only size messages from WSPay or our own return pages are trusted.
        iframeResizer({ checkOrigin: trustedIframeOrigins() }, `#wsPay-iframe-${paymentOption}`);
      }
    }
  }, [isLoaded]);

  if (loading) return null;
  if (error) return null;

  const myUrl = [config.REACT_APP_URL];

  const hiddenFields = {
    ...data?.getWSPayPaymentDetails,
    ReturnURL: [myUrl, `${AppRoutes.WEBSHOP.CHECKOUT_SUCCESS}`].join(''),
    CancelURL: [[myUrl, `${AppRoutes.WEBSHOP.STEP_4}`].join(''), offerId].join('/'),
    ReturnErrorURL: [myUrl, `${AppRoutes.WEBSHOP.CHECKOUT_FAILURE}`].join(''),
    __typename: undefined
  };

  const renderHiddenFields = (fields: { [key: string]: string | undefined | null }) => Object.keys(fields).map((key) => {
    if (fields[key] === undefined || fields[key] === null) return null;
    return <input key={key} type="hidden" name={key} value={fields[key]!} />
  });

  return (
    <div>
      <form ref={formRef} name="pay" action={config.REACT_APP_WSPAY_URL} method="POST" target={`wsPay-iframe-${paymentOption}`}>
        {renderHiddenFields(hiddenFields)}
      </form>
      <iframe title={title} name={`wsPay-iframe-${paymentOption}`} id={`wsPay-iframe-${paymentOption}`} style={{ width: '100%', minHeight: '420px', border: 'none' }}></iframe>
    </div>
  );
};
